module.exports = __webpack_public_path__ + "img/banner.73eceb33.png";